
import React, { useState } from "react";
import ProjectTab from "./tabs/ProjectTab";
import ClientTab from "./tabs/ClientTab";
import ConsultantTab from "./tabs/ConsultantTab";
import TaskTab from "./tabs/TaskTab";
import FinancialTab from "./tabs/FinancialTab";
import FeedbackTab from "./tabs/FeedbackTab";

const TABS = ["Project", "Client", "Consultant", "Task", "Financial", "Feedback"];

function ProjectEditTabs({ data, onDataUpdate, onMinimize }) {
  const [activeTab, setActiveTab] = useState("Project");

  const handleUpdate = (section, updated) => {
    onDataUpdate(prev => ({ ...prev, [section]: updated }));
  };

  return (
    <div className="bg-gray-200 p-4 m-4 rounded shadow relative">
      {/* Minimize icon in top-right */}
      <button
        className="absolute top-2 right-5 text-gray-700 hover:text-red-500 font-extrabold text-2xl"
        onClick={onMinimize}
        title="Minimize"
      >
        &minus;
      </button>

      {/* Tabs */}
      <div className="flex gap-1 mb-3 flex-wrap">
        {TABS.map(tab => (
          <button
            key={tab}
            className={`px-3 py-1 rounded font-sm ${
              activeTab === tab ? "bg-blue-600 text-white" : "bg-gray-300 text-gray-800"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div>
        {activeTab === "Project" && (
          <ProjectTab data={data.project} onChange={(val) => handleUpdate("project", val)} />
        )}
        {activeTab === "Client" && (
          <ClientTab data={data.client} onChange={(val) => handleUpdate("client", val)} />
        )}
        {activeTab === "Consultant" && (
          <ConsultantTab data={data.consultant} onChange={(val) => handleUpdate("consultant", val)} />
        )}
        {activeTab === "Task" && (
          <TaskTab data={data.task} onChange={(val) => handleUpdate("task", val)} />
        )}
        {activeTab === "Financial" && (
          <FinancialTab data={data.financial} onChange={(val) => handleUpdate("financial", val)} />
        )}
        {activeTab === "Feedback" && (
          <FeedbackTab data={data.feedback || {}} onChange={(val) => handleUpdate("feedback", val)} />
        )}
      </div>
    </div>
  );
}

export default ProjectEditTabs;

